// TODO: Move assets to the gratitude-gauge directory after feature flag is removed
import { Center, Image, StyleProps } from '@chakra-ui/react';
import { FC } from 'react';

import { rem } from '../../../design-system/utils';
import { useLocalStorage } from '../../../lib/storage';
import { Drink, getMeaningfulMeterImage } from '../give-box/utils/meaningful-meter-image';

type CupFillerProps = StyleProps & {
	percentage: number;
};

const DRINKS = [Drink.Juice, Drink.Tea, Drink.Coffee, Drink.BubbleTea, Drink.Cocoa];

export const CupFiller: FC<CupFillerProps> = ({ percentage, ...rest }) => {
	const [drink, setDrink] = useLocalStorage('gratitude-gauge-open:cup', DRINKS[Math.floor(Math.random() * DRINKS.length)]);

	const handleClick = () => {
		if (drink) {
			setDrink(DRINKS[(DRINKS.indexOf(drink) + 1) % DRINKS.length]);
		}
	};

	return (
		<Center boxSize={rem(54)} borderRadius="md" bgColor="purple.300" {...rest}>
			<Image
				src={getMeaningfulMeterImage(percentage, drink)}
				onClick={handleClick}
				boxSize={10}
				data-testid="drink-image"
				cursor="pointer"
				_active={{ animation: 'dissolve 4s linear forwards' }}
			/>
		</Center>
	);
};
